<template>
    <div class="">
        <div v-if="cmpt.componentName=='DateRangeField'">
            <div class="approve-detail_row">
                <span class="approve-detail_title">{{cmpt.props.label[0]}}</span>
                <span class="approve-detail_label">{{cmpt.value && cmpt.value.length >= 1 ? cmpt.value[0] : ''}}</span>
            </div>
            <div class="approve-detail_row">
                <span class="approve-detail_title">{{cmpt.props.label[1]}}</span>
                <span class="approve-detail_label">{{cmpt.value && cmpt.value.length >= 2 ? cmpt.value[1] : ''}}</span>
            </div>
            <div class="approve-detail_row"
                 v-if="cmpt.props.duration && cmpt.value && cmpt.value.length>=3 && cmpt.value[2]">
                <span class="approve-detail_title">{{cmpt.props.durationLabel + '('+cmpt.props.unit+')'}}</span>
                <span class="approve-detail_label">{{cmpt.value && cmpt.value.length >= 3 ? cmpt.value[2] : ''}}</span>
            </div>
        </div>
        <div v-else-if="cmpt.componentName=='TextNote'">
            <div v-if="cmpt.props.hiddenInApprovalDetail == false"
                 class="approve-detail-textnote">
                <div style="margin-bottom: 8px; font-size: 15px">{{cmpt.props.label}}</div>
                <a v-if="cmpt.props.link" :href="cmpt.props.link">
                    <u>{{cmpt.props.content}}</u>
                </a>
                <div v-else
                     v-html="cmpt.props.content.replace(/\n/g, '<br/>')"></div>
            </div>
        </div>
        <div v-else-if="cmpt.componentName=='PhotoField'">
            <div class="approve-detail_row" style="flex-direction: column">
                <span class="approve-detail_title">{{cmpt.props.label}}</span>
                <span class="approve-detail_label" style="margin-top: 12px; text-align: left">
                                <van-row>
                                    <van-col v-for="(image, i) in cmpt.value" :key=i span="4">
                                        <div>
                                            <img style="width: 45px; height: 45px"
                                                 :src="getImagePreviewUrl(image.fileId)"
                                                 @click="showImage(i)"/>
                                        </div>
                                    </van-col>
                                </van-row>
                            </span>
            </div>
        </div>
        <div v-else-if="cmpt.componentName=='Attachment'">
            <div class="approve-detail_row" style="flex-direction: column; padding-bottom: 5px">
                <span class="approve-detail_title">{{cmpt.props.label}}</span>
                <span class="approve-detail_label" style="text-align: left; padding: 5px 0px 5px 0px">
                                <div v-for="(attach,n) in cmpt.value" :key="n">
                                    <div class="approve-detail-row-attach" @click="showFile(n)">
                                        <img style="height: 45px; width: 45px; margin-right: 10px"
                                             :src="getFileTypeImg(attach.name)">
                                        <div>
                                            <div style="color: #A3AEB9; font-size: 15px">{{attach.name}}</div>
                                            <div
                                                style="color: #E2E6E9; font-size: 13px; margin-top: 5px;">{{filterCloudUnit(attach.size)}}</div>
                                        </div>
                                    </div>
                                </div>
                            </span>
            </div>
        </div>
        <div v-else-if="cmpt.componentName=='ExternalContactField'" class="approve-detail_row">
            <span class="approve-detail_title" style="line-height: 20px">{{cmpt.props.label}}</span>
            <div class="approve-detail_label" style="line-height: 20px">
                <span v-for="(item, i) in cmpt.value" :key="i">
                    <span style="color: #70affa" @click="showCustomerInfo(item.customerId)">{{item.customerName}}</span>
                    <span v-if="i < cmpt.value.length-1">、</span>
                </span>
            </div>
        </div>
        <div
            v-else-if="cmpt.componentName=='InnerContactField' || cmpt.componentName=='HrField' || cmpt.componentName=='RoleField'"
            class="approve-detail_row">
            <span class="approve-detail_title" style="line-height: 20px">{{cmpt.props.label}}</span>
            <div class="approve-detail_label" style="line-height: 20px">
                <span v-for="(item, i) in cmpt.value" :key="i">
                    <span style="color: #70affa" @click="showUserInfo(item.profileId)">{{item.realName}}</span>
                    <span v-if="i < cmpt.value.length-1">、</span>
                </span>
            </div>
        </div>
        <div v-else-if="cmpt.componentName=='DepartmentField'"
             class="approve-detail_row">
            <span class="approve-detail_title">{{cmpt.props.label}}</span>
            <span class="approve-detail_label">{{getDepName(cmpt.value)}}</span>
        </div>
        <div v-else-if="cmpt.componentName=='TimeAndLocationField'"
             class="approve-detail_row">
            <span class="approve-detail_title">{{cmpt.props.label[1]}}</span>
            <span class="approve-detail_label">{{cmpt.value.address}}</span>
        </div>
        <div v-else-if="cmpt.componentName=='RelateField'">
            <div class="approve-detail_row" style="flex-direction: column">
                <span class="approve-detail_title">{{cmpt.props.label}}</span>
                <span class="approve-detail_label" style="text-align: left">
                    <div v-for="(relate,n) in cmpt.value" :key="n">
                        <div
                            class="cell-item-relate-detial" @click="showRelate(relate)">
                            <img width="15px" src="../../assets/img/icon/链接@2x.png">
                            <span
                                style="font-size: 14px;flex: 1;margin-left: 10px">{{relate.title}}</span>
                            <span style="font-size: 13px;margin-left: 10px; word-break: keep-all">
                                <span class="approve-pending-color"
                                      v-if="relate.statusCd == '1'">审批中</span>
                                <span class="approve-reject-color"
                                      v-else-if="relate.statusCd == '2'">未通过</span>
                                <span class="approve-agree-color"
                                      v-else-if="relate.statusCd == '3'">已同意</span>
                                <span class="approve-withdrawn-color"
                                      v-else-if="relate.statusCd == '5'">已撤回</span>
                                <span v-else>
                                    <van-loading type="spinner" size="14px"/>
                                </span>
                            </span>
                        </div>
                    </div>
                </span>
            </div>
        </div>
        <div v-else-if="cmpt.componentName=='DocumentField'">
            <div class="approve-detail_row" style="flex-direction: column">
                <span class="approve-detail_title">{{cmpt.props.label}}</span>
                <span class="approve-detail_label" style="text-align: left">
                    <div v-for="(document,n) in cmpt.value" :key="n">
                        <div
                            class="cell-item-relate-detial" @click="showDocument(document)">
                            <img width="15px" src="../../assets/img/icon/链接@2x.png">
                            <span
                                style="font-size: 14px;flex: 1;margin-left: 10px">{{document.title}}</span>
                        </div>
                    </div>
                </span>
            </div>
        </div>
        <div v-else-if="cmpt.componentName=='TextareaField'" class="approve-detail_row" style="flex-direction: column">
            <span class="approve-detail_title">{{cmpt.props.label}}</span>
            <span class="approve-detail_label" style="text-align: left; margin-top: 12px"
                  v-html="zhuanhua(cmpt.value)"></span>
        </div>
        <div v-else-if="cmpt.componentName=='TableField'">
            <div v-if="cmpt.children && cmpt.children.length > 0">
                <div v-for="(childA, childAIndex) in cmpt.children" :key="childAIndex">
                    <div class="detail-tab-title">
                        {{cmpt.props.label}}({{childAIndex}})
                    </div>
                    <detailCompnents v-for="(childB, k) in childA"
                                     :key="childAIndex+'-'+k"
                                     :cmpt="childB"></detailCompnents>
                </div>
            </div>
            <div v-if="cmpt.children && cmpt.children.length > 0">
                <div v-for="(totalChild, totalIndex) in cmpt.children" :key="totalIndex"
                     style="font-size: 14px;">
                    <div v-for="(totalChildB, totalIndexB) in totalChild" :key="totalIndexB">
                        <div v-if="totalIndex == 0">
                            <div v-if="totalChildB.componentName=='NumberField' && totalChildB.props.statistics">
                                <div
                                    style="display: flex; flex-direction: row; align-items: start; padding: 10px 15px 15px 15px">
                                    <span class="ellipsis-multi-1" style="font-size: 15px; color: #596c83; text-align: left">总{{totalChildB.props.label}}：</span>
                                    <span style="flex: 1; font-size: 15px; color: #596c83;margin-left: 10px; text-align: left">{{sumTable(totalChildB.props.id)}}</span>
                                </div>
                            </div>
                            <div v-if="totalChildB.componentName==='MoneyField' && totalChildB.props.statistics">
                                <div
                                    style="display: flex; flex-direction: row; align-items: start; padding: 10px 15px 15px 15px">
                                    <span class="ellipsis-multi-1" style="font-size: 15px; color: #596c83; text-align: left">总{{totalChildB.props.label}}：</span>
                                    <span style="flex: 1; font-size: 15px; color: #596c83;margin-left: 10px; text-align: left">{{parseFloat(sumTable(totalChildB.props.id)).toFixed(2)}}</span>
                                </div>
                                <div
                                    style="display: flex; flex-direction: row; align-items: start; padding: 10px 15px 15px 15px">
                                    <span class="ellipsis-multi-1" style="font-size: 13px; color: #596c83; text-align: left">大写：</span>
                                    <span style="flex: 1; font-size: 13px; color: #596c83;margin-left: 10px; text-align: left" v-if="totalChildB.orderStateY === 'ok'">{{smalltoBIG(parseFloat(sumTable(totalChildB.props.id) / 100).toFixed(2))}}</span>
                                    <span style="flex: 1; font-size: 13px; color: #596c83;margin-left: 10px; text-align: left" v-else-if="totalChildB.orderStateY === 'other'">{{smalltoBIG(parseFloat(sumTable(totalChildB.props.id)).toFixed(2))}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <div v-else-if="isSuiteCompnent(cmpt.componentName)">
            <detailCompnents v-for="(child, k) in cmpt.children"
                             :key="k"
                             :cmpt="child"></detailCompnents>
        </div>

        <div v-else-if="cmpt.componentName=='PurchaseQuotedPriceField'" class="approve-detail_row">
            <span class="approve-detail_title">
                {{cmpt.props.label}}
            </span>
            <span class="approve-detail_label" style="text-decoration:underline; color: #07affa"
                  @click="goNative('purchase:quotedPrice:list', {'purchasePlanId': cmpt.value.purchasePlanId})">{{cmpt.value.purchasePlanNo}}</span>
        </div>
        <div v-else-if="cmpt.componentName=='OrderField'" class="approve-detail_row">
            <span class="approve-detail_title">
                {{cmpt.props.label}}
            </span>
            <span class="approve-detail_label" style="text-decoration:underline; color: #07affa"
                  @click="showOrderInfo(cmpt.value)">{{cmpt.value}}</span>
        </div>
        <div v-else-if="cmpt.componentName=='SkipControl'" class="approve-detail_row">
            <span class="approve-detail_title">
                {{cmpt.props.label}}
            </span>
            <span class="approve-detail_label" style="text-decoration:underline; color: #07affa"
                  @click="goNative2(cmpt.props.urls)">{{cmpt.value.title}}</span>
        </div>
        <div v-else>
            <div v-if="cmpt.value" class="approve-detail_row">
               <span class="approve-detail_title">
                 {{cmpt.props.label}}{{cmpt.componentName=='NumberField' && cmpt.props.unit ? '('+cmpt.props.unit+')' : ''}}
                </span>
                <span v-if="cmpt.componentName=='MultiSelectField'"
                      class="approve-detail_label">{{cmpt.value.join('; ')}}</span>
                <span v-else-if="cmpt.componentName==='MoneyField' && cmpt.orderStateY === 'ok'"
                      class="approve-detail_label">
                {{parseFloat(parseFloat(cmpt.value) / 100).toFixed(2)}}
                </span>
                <span v-else-if="cmpt.componentName==='MoneyField' && cmpt.orderStateY === 'other'"
                      class="approve-detail_label">
                {{parseFloat(cmpt.value).toFixed(2)}}
                </span>
                <span v-else class="approve-detail_label">{{cmpt.value}}</span>
            </div>
        </div>
        <div v-if="cmpt.componentName!='TextNote'" class="onepx-h" style="margin-left: 15px"></div>
        <div v-if="cmpt.value && cmpt.componentName==='MoneyField' && cmpt.props.notUpper">
            <div
                style="display: flex; flex-direction: row; align-items: start; padding: 10px 15px 15px 15px">
                <span class="ellipsis-multi-1"
                      style="font-size: 13px; color: #596c83; text-align: left">大写</span>
                <span style="flex: 1; font-size: 13px; color: #596c83;margin-left: 10px; text-align: right" v-if="cmpt.orderStateY === 'ok'">{{smalltoBIG(parseFloat(parseFloat(cmpt.value) / 100).toFixed(2))}}</span>
                <span style="flex: 1; font-size: 13px; color: #596c83;margin-left: 10px; text-align: right" v-else-if="cmpt.orderStateY === 'other'">{{smalltoBIG(parseFloat(cmpt.value).toFixed(2))}}</span>
            </div>
        </div>
    </div>
</template>

<script>
    import head from '../../mixins/head';
    import AutoSuite from '../../mixins/auto-suite';
    import detailCompnents from './detailCompnents';
    import { digitUppercase } from '../../utils/digitUppercase';

    export default {
        components: { detailCompnents },
        name: 'detailCompnents',
        mixins: [head, AutoSuite],
        data() {
            return {};
        },
        props: {
            cmpt: {
                type: Object,
                default: function () {
                    return {};
                }
            }
        },
        watch: {},
        computed: {},
        created() {
        },
        mounted() {
        },

        beforeDestroy() {
            delete window['refreshQuotedPrice_' + this.cmpt.model];
        },
        methods: {

            zhuanhua(str) {
                if (str) {
                    return str.replace(/\n|\r\n/g, '<br/>').replace(/ /g, '&nbsp;');
                }
                return str;
            },

            getDepName(data) {
                if (data && data.length) {
                    let names = [];
                    for (let i = 0; i < data.length; i++) {
                        names.push(data[i].depName);
                    }
                    return names.join('、');
                }
                return '';
            },

            calculateDuration() {
                if (this.cmpt.value[0] && this.cmpt.value[1]) {
                    let start = moment(this.cmpt.value[0]);
                    let end = moment(this.cmpt.value[1]);
                    if (this.cmpt.props.unit == '天') {
                        return end.diff(start, 'day') + 1;
                    } else if (this.cmpt.props.unit == '小时') {
                        return end.diff(start, 'hour');
                    }
                }
                return '';
            },

            getImagePreviewUrl(fileId) {
                return this.getFileLink(fileId);
            },

            showImage(i) {
                let images = [];
                for (let i = 0; i < this.cmpt.value.length; i++) {
                    images.push(this.getImagePreviewUrl(this.cmpt.value[i].fileId));
                }
                window.imagePreview(images, i);
            },

            showFile(i) {
                window.filePreview(this.cmpt.value[i]);
            },

            showUserInfo(profileId) {
                window.showUserInfo(profileId);
            },

            showCustomerInfo(customerId) {
                window.showCustomerInfo(customerId);
            },

            showOrderInfo(orderNo) {
                window.showOrderInfo(orderNo, 2);
            },

            goNative(scheme, params, callback) {
                window.goNative(scheme, params, callback);
            },


            goNative2(urls) {
                if (/(BD-ANDROID)/i.test(navigator.userAgent)) {
                    let data = JSON.parse(urls.android);
                    window.goNative2(data.action, data.params, data.callback);
                // } else if (/(BD-IOS)/i.test(navigator.userAgent)) {
                } else {
                    let data = JSON.parse(urls.ios);
                    window.goNative(data.action, data.params, data.callback);
                }
            },

            getFileTypeImg(fileName) {
                return window.getFileTypeImg(fileName);
            },

            filterCloudUnit(capacity) {
                return window.filterCloudUnit(capacity);
            },

            sumTable(id) {
                let total = 0;
                for (let i = 0; i < this.cmpt.children.length; i++) {
                    let item = this.cmpt.children[i];
                    for (let j = 0; j < item.length; j++) {
                        let child = item[j];
                        if (child.props.id == id) {
                            if (child.value) {
                                total += child.value * 1;
                            }
                        }
                    }
                }
                return total;
            },

            showRelate(item) {
                window.showRelate(item);
            },

            showDocument(item) {
                window.showDocument(item);
            },

            /** 数字金额大写转换(可以处理整数,小数,负数) */
            smalltoBIG(n) {
                return digitUppercase(n);
            }
        }
    };
</script>

<style lang="scss"
       scoped>
    @import '../../assets/scss/approve.scss';
    @import '../../assets/scss/approve-detail.scss';
</style>
